export default {
  firstname: "Vorname",
  lastname: "Nachname",
  phone: "Telefon",
  email: "E-Mail",
  yes: "ja",
  no: "nein",
  date: "Datum",
  signature: "Unterschrift",
  number: "Nummer",
  amount: "Betrag"
}
